import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "size", "icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { getRoundButtonTheme } from '../../themes';
import styles from '../../styles/roundButton.module.css';

/**
 * Компонент круглой кнопки с иконкой. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать иконки. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 */
import { jsx as _jsx } from "react/jsx-runtime";
var RoundButtonComponent = /*#__PURE__*/React.forwardRef(function RoundedButton(_ref, ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'fill_light' : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'M' : _ref$size,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isLightTheme = theme === 'fill_light';
  var themeClasses = getRoundButtonTheme(theme);
  var buttonClasses = clsx(styles['button'], styles[size], themeClasses['button']);
  var preparedIcon = /*#__PURE__*/React.cloneElement(icon, {
    color: isLightTheme ? 'icon-secondary-default' : 'icon-inverted-default'
  });
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    className: buttonClasses,
    ref: ref,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['icon'],
      children: preparedIcon
    })
  }));
});
export var RoundButton = /*#__PURE__*/React.memo(RoundButtonComponent);